// extracted by mini-css-extract-plugin
export default {"subscreentitle":"SubScreenTitle_subscreentitle__MeuaV","modalscreentitle":"SubScreenTitle_modalscreentitle__AKLic"};